<template>
	<div class="content_main">
		<div style="margin-top: 10px">
			<a-button v-if="financialInputConsumables" type="primary" @click="Warehousing">品类录入</a-button>
			<a-button v-if="financialExportConsumables" type="primary" @click="exp"> 数据导出 </a-button>
			<!-- <a-button type="primary" @click="Input">录入</a-button> -->
		</div>
		<div class="content_main_top">
			<a-select show-search allowClear placeholder="类别" class="margin_self" v-model="asset_type"
				style="width: 120px" @keyup.enter.native="query">
				<a-select-option :value="item.value" v-for="(item, index) in goodsType" :key="index">
					{{ item.label }}
				</a-select-option>
			</a-select>
			<a-input v-model="name" allowClear class="a_input_self margin_self" placeholder="品类名称"
				@keyup.enter.native="query" />
			<a-input v-model="asset_sn" allowClear class="a_input_self margin_self" placeholder="品类编号"
				@keyup.enter.native="query" />
			<!-- <a-select show-search allowClear placeholder="请选择审核状态" class="a_select_self margin_self" @change="handleChange"
					 disabled>
						<a-select-option value="jack"> Jack </a-select-option>
						<a-select-option value="lucy"> Lucy </a-select-option>
						<a-select-option value="Yiminghe"> yiminghe </a-select-option>
					</a-select> -->
			<a-select show-search allowClear v-model="company_id" placeholder="公司名称" class="a_select_self margin_self"
				@keyup.enter.native="query">
				<a-select-option :value="item.deptId" v-for="(item, index) in companylist" :key="index">
					{{ item.title }}
				</a-select-option>
			</a-select>
			<a-button v-if="financialQueryConsumables" type="primary" @click="query"> 查询 </a-button>
			<a-button type="primary" ghost @click="result"> 重置 </a-button>
		</div>
		<div class="content_main_center" id="content_main_center_scroll" style="height: calc(100% - 142px)">
			<a-table :columns="columns" :data-source="data" bordered :pagination="false"
				:scroll="{ x: 1200, y: scroll_y }" :components="drag(columns)">
				<!-- <span slot="id" slot-scope="text">
					<template>
						{{text.toString().length == 1 ? 'HC'+'000'+text:text.toString().length == 2 ?'HC'+'00'+text:text.toString().length == 3 ?'HC'+'0'+text:'HC'+text }}
					</template>
				</span> -->
				<span slot="index" slot-scope="text, record, index">
					{{ (current - 1) * pageSize + index + 1 }}
				</span>
				<span slot="isInspected" slot-scope="text">
					{{ instrumentMap[text] }}
				</span>
				<span slot="spu_type" slot-scope="text">
					{{ text ? goodsTypeObj[text] : '' }}
				</span>
				<!-- <span slot="state" slot-scope="text">
					<template>
						<a-tag :color="colors[text]">
							{{ text ? statusMap[text] : '' }}
						</a-tag>

					</template>
				</span> -->
				<span slot="hazard_type" slot-scope="text">
					{{ text ? text.replace('其他;', '').replace(/;/g, '、') : '' }}
				</span>
				<span slot="storage_cond" slot-scope="text">
					{{ text ? text.replace('其他;', '').replace(/;/g, '、') : '' }}
				</span>
				<span slot="is_inspected" slot-scope="text">
					{{ instrumentMap[text] }}
				</span>
				<span slot="dept_id" slot-scope="text">
					{{ text ? deptMap[text].text : '' }}
				</span>
				<span slot="action" slot-scope="text, record">
					<a v-if="financialEditConsumables" @click="edit(record)">编辑</a>
					<a-divider v-if="financialDetailsConsumables" type="vertical" />
					<a v-if="financialDetailsConsumables" @click="details(record)">详情</a>
				</span>
			</a-table>
		</div>
		<div class="content_main_bot">
			<a-pagination v-model="current" show-size-changer :page-size.sync="pageSize" :total="total"
				@showSizeChange="showSizeChange" :pageSizeOptions="['10', '20', '30', '50']"
				@change="onShowSizeChange" />
		</div>
		<a-modal v-model="changevisible" title="批量修改金额">
			<template slot="footer">
				<a-button key="back" @click="moneyCancel"> 取消 </a-button>
				<a-button key="submit" type="primary" @click="moneyOk"> 保存 </a-button>
			</template>
			<a-table :data-source="selectedRow" bordered :pagination="false">
				<a-table-column key="name" title="物品名称" data-index="name" />
				<a-table-column key="model" title="规格型号" data-index="model" />
				<a-table-column key="asset_sn" title="物品编号" data-index="asset_sn" />
				<a-table-column key="value" title="当前估值" data-index="value">
					<template slot-scope="text, record">
						<a-input v-model="record.value" />
					</template>
				</a-table-column>
			</a-table>
		</a-modal>
		<a-modal title="流动资产-详情" :visible="detailsvisible" @cancel="detailsCancel" width="880px">
			<template slot="footer">
				<a-button key="back" @click="detailsOk"> 取消 </a-button>
			</template>
			<a-form-model :model="detailsrow" style="height: 450px">
				<a-form-model-item label="品类编号" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ detailsrow.spu_sn }}</span>
				</a-form-model-item>
				<a-form-model-item label="品类名称" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ detailsrow.name }}</span>
				</a-form-model-item>
				<a-form-model-item label="规格型号" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ detailsrow.model }}</span>
				</a-form-model-item>
				<a-form-model-item label="数　　量" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ detailsrow.storage_num }}</span>
				</a-form-model-item>
				<a-form-model-item label="采购均价" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ detailsrow.price }}</span>
				</a-form-model-item>
				<a-form-model-item label="单　　位" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ detailsrow.unit }}</span>
				</a-form-model-item>
				<a-form-model-item label="类　　别" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ detailsrow.spu_type ? goodsTypeObj[detailsrow.spu_type] : '' }}</span>
				</a-form-model-item>
				<a-form-model-item label="是否已检定" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ instrumentMap[detailsrow.is_inspected] }}</span>
				</a-form-model-item>
				<a-form-model-item label="公司名称" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ detailsrow.company_name }}</span>
				</a-form-model-item>
				<a-form-model-item label="备　　注" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ detailsrow.notes }}</span>
				</a-form-model-item>
				<a-form-model-item label="录入时间" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ detailsrow.create_time }}</span>
				</a-form-model-item>
				<a-form-model-item label="录 入 人 " :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ detailsrow.create_by }}</span>
				</a-form-model-item>
				<a-form-model-item label="维护时间" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ detailsrow.update_time }}</span>
				</a-form-model-item>
				<a-form-model-item label="维 护 人 " :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ detailsrow.update_by }}</span>
				</a-form-model-item>
				<a-form-model-item label="是否为制毒、制爆" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ detailsrow.hazard_type ? detailsrow.hazard_type.replace('其他;', '').replace(/;/g, '、') : ''
					}}</span>
				</a-form-model-item>
				<a-form-model-item label="存放条件" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ detailsrow.storage_cond ? detailsrow.storage_cond.replace('其他;', '').replace(/;/g, '、') :
							''
					}}</span>
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		<a-modal title="流动资产-编辑" :visible="editvisible" @ok="editOk" @cancel="editCancel" width="880px"
			:maskClosable="false">
			<template slot="footer">
				<a-button key="back" @click="editCancel"> 取消 </a-button>
				<a-button type="primary" @click="editOk"> 保存 </a-button>
			</template>
			<a-form-model :model="detailsrow" style="height: 630px">
				<a-form-model-item label="品类编号" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ detailsrow.spu_sn }}</span>
				</a-form-model-item>
				<a-form-model-item label="品类名称" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ detailsrow.name }}</span>
				</a-form-model-item>
				<a-form-model-item label="规格型号" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<a-input allowClear v-model="detailsrow.model" disabled placeholder="请输入" />
				</a-form-model-item>
				<a-form-model-item label="数量" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ detailsrow.storage_num }}</span>
				</a-form-model-item>
				<a-form-model-item label="采购均价" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<a-input allowClear type="number" v-model="detailsrow.price" disabled placeholder="请输入" />
				</a-form-model-item>
				<a-form-model-item label="单位" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item"
					:rules="[{ required: true, trigger: 'blur' }]">
					<a-input allowClear v-model="detailsrow.unit" placeholder="请输入" />
				</a-form-model-item>
				<a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="资产类别" class="form_item"
					:rules="[{ required: true, trigger: 'blur' }]">
					<a-select allowClear v-model="detailsrow.spu_type" placeholder="请选择">
						<a-select-option :key="index" v-for="(item, index) in goodsType" :value="item.value">
							{{ item.label }}
						</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="是否已检定" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<a-select allowClear v-model="detailsrow.is_inspected" placeholder="请选择" disabled>
						<a-select-option :key="index" v-for="(item, index) in instrumentMap" :value="Number(index)">
							{{ item }}
						</a-select-option>
					</a-select>
				</a-form-model-item>
				<!-- <a-form-model-item label="检定日期" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item" v-if="this.detailsrow.is_inspected==1">
					<a-date-picker valueFormat="YYYY-MM-DD" allowClear v-model="detailsrow.inspect_time" placeholder="请输入" style="width: 277px" />
				</a-form-model-item>
				<a-form-model-item label="检定结果" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item" v-if="this.detailsrow.is_inspected==1">
					<a-input allowClear v-model="detailsrow.inspect_result" placeholder="请输入" />
				</a-form-model-item>
				<a-form-model-item label="检定周期" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item" v-if="this.detailsrow.is_inspected==1">
					<a-input allowClear v-model="detailsrow.inspect_cycle" placeholder="请输入" />
				</a-form-model-item> -->
				<!-- <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="物品状态" class="form_item">
					<a-select allowClear v-model="states" placeholder="请选择" disabled>
						<a-select-option :key="index" v-for="(item, index) in statusMap" :value="index">
							{{ item }}
						</a-select-option>
					</a-select>
				</a-form-model-item> -->
				<a-form-model-item label="公司名称" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<a-input allowClear disabled v-model="detailsrow.company_name" placeholder="请输入" />
				</a-form-model-item>
				<a-form-model-item label="备　　注" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<a-input allowClear v-model="detailsrow.notes" placeholder="请输入" />
				</a-form-model-item>
				<a-form-model-item label="录入时间" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<a-input allowClear v-model="detailsrow.create_time" disabled placeholder="请输入" />
				</a-form-model-item>
				<a-form-model-item label="录 入 人 " :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<a-input allowClear v-model="detailsrow.create_by" disabled placeholder="请输入" />
				</a-form-model-item>
				<a-form-model-item label="维护时间" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<a-input allowClear v-model="detailsrow.update_time" disabled placeholder="请输入" />
				</a-form-model-item>
				<a-form-model-item label="维 护 人 " :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<a-input allowClear v-model="detailsrow.update_by" disabled placeholder="请输入" />
				</a-form-model-item>
				<!-- <a-form-model-item label="定值" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<a-input allowClear v-model="detailsrow.fixed_value" placeholder="请输入" />
				</a-form-model-item>
				<a-form-model-item label="存放位置" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<a-input allowClear v-model="detailsrow.storage_loc" placeholder="请输入" />
				</a-form-model-item>
				<a-form-model-item label="物品单价" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<a-input allowClear v-model="detailsrow.value" placeholder="请输入" />
				</a-form-model-item>
				<a-form-model-item label="采购时间" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<a-date-picker valueFormat="YYYY-MM-DD" allowClear v-model="detailsrow.purchase_time" placeholder="请输入" style="width: 277px" />
				</a-form-model-item>
				<a-form-model-item label="采购总额" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<a-input @blur="changepur_value" allowClear v-model="detailsrow.value" placeholder="请输入" />
				</a-form-model-item>
				<a-form-model-item label="采购数量" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<a-input @blur="changepur_value" allowClear v-model="detailsrow.amount" placeholder="请输入" />
				</a-form-model-item>
				<a-form-model-item label="采购单价" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<a-input allowClear v-model="detailsrow.price" placeholder="请输入" />
				</a-form-model-item>
				<a-form-model-item label="生产厂家" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<a-input allowClear v-model="detailsrow.manufacturer" placeholder="请输入" />
				</a-form-model-item>
				<a-form-model-item label="到货时间" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<a-date-picker valueFormat="YYYY-MM-DD" allowClear v-model="detailsrow.arrive_time" placeholder="请输入" style="width: 277px" />
				</a-form-model-item>
				<a-form-model-item label="使用人(保管人)" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<a-input allowClear v-model="detailsrow.keeper" placeholder="请输入" />
				</a-form-model-item>
				<a-form-model-item label="生产批号" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<a-input allowClear v-model="detailsrow.factory_batch" placeholder="请输入" />
				</a-form-model-item>
				<a-form-model-item label="供应商" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<a-input allowClear v-model="detailsrow.dealer" placeholder="请输入" />
				</a-form-model-item>
				<a-form-model-item label="准用说明" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<a-input allowClear v-model="detailsrow.permit" placeholder="请输入" />
				</a-form-model-item>
				<a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="责任部门" class="form_item" :rules="[{ required: true, trigger: 'blur' }]">
					<a-tree-select :treeData="deptTree" placeholder="负责部门" v-model="detailsrow.dept_id" treeDefaultExpandAll>
					</a-tree-select>
				</a-form-model-item>
				<a-form-model-item label="责任人" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<a-input allowClear v-model="detailsrow.charger" placeholder="请输入" />
				</a-form-model-item> -->
				<a-form-model-item label="是否为制毒、制爆" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item3">
					<a-checkbox-group v-model="hazard_types" :options="checkout" @change="checkoutChange" />
					<a-input v-model="els" style="width: 200px" :disabled="hazard_types.indexOf('其他') == -1" />
				</a-form-model-item>
				<a-form-model-item label="存放条件" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item3">
					<a-checkbox-group v-model="storage_conds" :options="condition" @change="conditionChange" />
					<a-input v-model="other" style="width: 200px" :disabled="storage_conds.indexOf('其他') == -1" />
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		<a-modal title="流动资产-录入" v-model="Warevisible" width="1000px" :maskClosable="false">
			<template slot="footer">
				<a-button key="back" @click="WareCancel"> 取消 </a-button>
				<a-button key="submit" type="primary" @click="Wareprese"> 录入 </a-button>
			</template>
			<a-form :form="form" :labelCol="labelCol" :wrapperCol="wrapperCol">
				<a-row>
					<a-col :span="8">
						<a-form-item label="公司名称">
							<a-input allowClear
								v-decorator="['company_id', { rules: [{ required: true, message: '请填写公司名称!' }] }]"
								disabled />
						</a-form-item>
					</a-col>
					<a-col :span="8">
						<a-form-item label="品类名称">
							<a-input allowClear
								v-decorator="['name', { rules: [{ required: true, message: '请填写物品名称!' }] }]"
								placeholder="请输入物品名称" />
						</a-form-item>
					</a-col>
					<a-col :span="8">
						<a-form-item label="规格型号">
							<a-input allowClear
								v-decorator="['model', { rules: [{ required: true, message: '请填写规格型号!' }] }]"
								placeholder="请输入型号或名称" />
						</a-form-item>
					</a-col>
				</a-row>
				<!-- <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="物品编号" class="form_item2">
					<a-input allowClear v-decorator="['asset_sn', { rules: [{ required: true, message: '请填写物品编号!' }] }]" disabled />
				</a-form-item> -->
				<a-row>
					<a-col :span="8">
						<a-form-item label="单　　位">
							<a-input allowClear
								v-decorator="['unit', { rules: [{ required: true, message: '请填写物品单位!' }] }]"
								placeholder="请输入物品单位" />
						</a-form-item>
					</a-col>
					<a-col :span="8">
						<a-form-item label="类　　别">
							<a-select allowClear
								v-decorator="['spu_type', { rules: [{ required: true, message: '请填写资产类别!' }] }]"
								placeholder="请选择">
								<a-select-option :key="index" v-for="(item, index) in goodsType" :value="item.value">
									{{ item.label }}
								</a-select-option>
							</a-select>
						</a-form-item>
					</a-col>
					<a-col :span="8">
						<a-form-item label="是否已检定">
							<a-select allowClear
								v-decorator="['is_inspected', { rules: [{ required: true, message: '请选择是否已检定!' }] }]"
								placeholder="请选择">
								<a-select-option :key="index" v-for="(item, index) in instrumentMap" :value="index">
									{{ item }}
								</a-select-option>
							</a-select>
						</a-form-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-item label="备　　注">
							<a-input allowClear v-decorator="['notes']" placeholder="请输入备注" />
						</a-form-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-item label="是否为制毒、制爆">
							<a-checkbox-group
								v-decorator="['hazard_type', { rules: [{ required: true, message: '请选择!' }] }]"
								:options="checkout" @change="checkoutChange2" />
							<a-input v-model="elss" style="width: 200px"
								:disabled="form.getFieldValue('hazard_type') ? form.getFieldValue('hazard_type').indexOf('其他') == -1 : ''" />
						</a-form-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="存放条件">
							<a-checkbox-group
								v-decorator="['storage_cond', { rules: [{ required: true, message: '请选择!' }] }]"
								:options="condition" @change="conditionChange2" />
							<a-input v-model="others" style="width: 200px" :disabled="
	form.getFieldValue('storage_cond') ? form.getFieldValue('storage_cond').indexOf('其他') == -1 : ''
							" />
						</a-form-model-item>
					</a-col>
				</a-row>
			</a-form>
		</a-modal>
	</div>
</template>
<script>
import { downLoadXlxs2 } from '@/utils/index'
import tableDragResize from '@/mixins/tableDragResize'
import {
	get_list,
	purchase,
	checkin,
	dict,
	dept_get,
	batch_save_value,
	update,
	// get_dept_tree,
	remove,
	// get_company_name,
	belong_company,
	// spu_update,
	get_spu_xlsx,
	consumablesList,
	addConsumables,
	editConsumables

} from '@/api/assetmenag'
import {
	getDeptListEnable
} from '@/api/system'
import {
	checkPermission
} from '@/utils/permissions'
import {
	ACCESS_TOKEN
} from '@/store/mutation-types'
import storage from 'store'
import {
	returnDept,
	get_dict
} from '@/utils/unit_axios.js'
import { tree_all, enableParent } from '@/api/purchase'
const deptMap = {}
const checkout = ['易制毒', '易制爆', '剧毒', '其他']
const condition = ['常温', '冷冻', '冷藏', '避光', '其他']
const columns = [{
	title: '序号',
	dataIndex: 'index',
	key: 'index',
	scopedSlots: {
		customRender: 'index',
	},
	width: 70,
	ellipsis: true,
}, {
	title: '公司名称',
	dataIndex: 'companyName',
	key: 'companyName',
	width: 150,
	ellipsis: true,
},
{
	title: '类别',
	dataIndex: 'spuTypeName',
	key: 'spuTypeName',
	scopedSlots: {
		customRender: 'spuTypeName',
	},
	width: 100,
	ellipsis: true,
},
{
	title: '品类编号',
	dataIndex: 'spuSn',
	key: 'spuSn',
	width: 100,
	ellipsis: true,
},
{
	title: '品类名称',
	dataIndex: 'name',
	key: 'name',
	width: 150,
	ellipsis: true,
},
{
	title: '规格型号',
	dataIndex: 'model',
	key: 'model',
	width: 150,
	ellipsis: true,
},
{
	title: '数量',
	dataIndex: 'storageNum',
	key: 'storageNum',
	width: 100,
	ellipsis: true,
},
{
	title: '单位',
	dataIndex: 'unit',
	key: 'unit',
	width: 100,
	ellipsis: true,
},
{
	title: '采购均价',
	dataIndex: 'price',
	key: 'price',
	width: 100,
	ellipsis: true,
},
{
	title: '是否已检定',
	dataIndex: 'isInspected',
	key: 'isInspected',
	scopedSlots: {
		customRender: 'isInspected',
	},
	width: 120,
	ellipsis: true,
},
// {
// 	title: '检定日期',
// 	dataIndex: 'inspect_time',
// 	key: 'inspect_time',
// 	width: 150,
// 	ellipsis: true,
// },
// {
// 	title: '检定结果',
// 	dataIndex: 'inspect_result',
// 	key: 'inspect_result',
// 	width: 150,
// 	ellipsis: true,
// },
// {
// 	title: '检定周期',
// 	dataIndex: 'inspect_cycle',
// 	key: 'inspect_cycle',
// 	width: 150,
// 	ellipsis: true,
// },
// {
// 	title: '物品状态',
// 	dataIndex: 'state',
// 	key: 'state',
// 	scopedSlots: {
// 		customRender: 'state',
// 	},
// 	width: 150,
// 	ellipsis: true,
// },
{
	title: '是否为制毒、制爆',
	dataIndex: 'hazardType',
	key: 'hazardType',
	scopedSlots: {
		customRender: 'hazardType',
	},
	width: 300,
	ellipsis: true,
},
// {
// 	title: '定值',
// 	dataIndex: 'fixed_value',
// 	key: 'fixed_value',
// 	width: 150,
// 	ellipsis: true,
// },

// {
// 	title: '生产批号',
// 	dataIndex: 'factory_batch',
// 	key: 'factory_batch',
// 	width: 150,
// 	ellipsis: true,
// },
// {
// 	title: '存放位置',
// 	dataIndex: 'storage_loc',
// 	key: 'storage_loc',
// 	width: 150,
// 	ellipsis: true,
// },
{
	title: '存放条件',
	dataIndex: 'storageCond',
	key: 'storageCond',
	scopedSlots: {
		customRender: 'storageCond',
	},
	width: 300,
	ellipsis: true,
},
// {
// 	title: '采购时间',
// 	dataIndex: 'purchase_time',
// 	key: 'purchase_time',
// 	width: 150,
// 	ellipsis: true,
// },
// {
// 	title: '采购单价',
// 	dataIndex: 'price',
// 	key: 'price',
// 	width: 150,
// 	ellipsis: true,
// },
// {
// 	title: '采购数量',
// 	dataIndex: 'amount',
// 	key: 'amount',
// 	width: 150,
// 	ellipsis: true,
// },
// {
// 	title: '生产厂家',
// 	dataIndex: 'manufacturer',
// 	key: 'manufacturer',
// 	width: 150,
// 	ellipsis: true,
// },
// {
// 	title: '到货日期',
// 	dataIndex: 'arrive_time',
// 	key: 'arrive_time',
// 	width: 150,
// 	ellipsis: true,
// },
// {
// 	title: '使用人(保管人)',
// 	dataIndex: 'keeper',
// 	key: 'keeper',
// 	width: 150,
// 	ellipsis: true,
// },

// {
// 	title: '供应商',
// 	dataIndex: 'dealer',
// 	key: 'dealer',
// 	width: 150,
// 	ellipsis: true,
// },

// {
// 	title: '准用说明',
// 	dataIndex: 'permit',
// 	key: 'permit',
// 	width: 150,
// 	ellipsis: true,
// },
// {
// 	title: '采购总额',
// 	dataIndex: 'value',
// 	key: 'value',
// 	width: 150,
// 	ellipsis: true,
// },
// {
// 	title: '责任部门',
// 	dataIndex: 'dept_id',
// 	key: 'dept_id',
// 	scopedSlots: {
// 		customRender: 'dept_id',
// 	},
// 	width: 150,
// 	ellipsis: true,
// },
// {
// 	title: '责任人',
// 	dataIndex: 'charger',
// 	key: 'charger',
// 	width: 150,
// 	ellipsis: true,
// },
{
	title: '备注',
	dataIndex: 'notes',
	key: 'notes',
	width: 150,
	ellipsis: true,
},
{
	title: '录入人',
	dataIndex: 'createBy',
	key: 'createBy',
	width: 150,
	ellipsis: true,
},
{
	title: '录入时间',
	dataIndex: 'createTime',
	key: 'createTime',
	width: 200,
	ellipsis: true,
},
{
	title: '维护人',
	dataIndex: 'updateBy',
	key: 'updateBy',
	width: 150,
	ellipsis: true,
},
{
	title: '维护时间',
	dataIndex: 'updateTime',
	key: 'updateTime',
	width: 200,
	ellipsis: true,
},
{
	title: '操作',
	key: 'action',
	scopedSlots: {
		customRender: 'action',
	},
	fixed: 'right',
	width: 150,
},
]
export default {
	mixins: [tableDragResize],
	data() {
		return {
			statusMap: '',
			dates: [],
			scroll_y: 150,
			checkout,
			condition,
			deptMap,
			operTypeMap: {},
			asset_type: undefined,
			changevisible: false,
			Warevisible: false,
			company_id: undefined,
			dept_id: undefined,
			data: [],
			companylist: [],
			checkList: [],
			checkList2: [],
			els: '',
			other: '',
			elss: '',
			others: '',
			deptlist: [],
			data2: [],
			data3: [],
			deptTree: [],
			assettype: [],
			columns,
			visible: false,
			visibleClaim: false,
			visibleexamine: false,
			editvisible: false,
			loading: false,
			Warehousingvisible: false,
			selectedRowKeys: [],
			selectedRow: [],
			name: '',
			asset_sn: '',
			state: '',
			start_date: '',
			num: 1,
			end_date: '',
			name2: '',
			asset_sn2: '',
			state2: '',
			purchase_time2: '',
			pageSize: 10,
			current: 1,
			total: 0,
			pageSize2: 10,
			current2: 1,
			total2: 0,
			pageSize3: 10,
			current3: 1,
			total3: 0,
			detailsrow: {},
			detailsrow: {},
			visible2: false,
			detailsvisible: false,
			form: this.$form.createForm(this),
			form2: this.$form.createForm(this),
			labelCol: {
				xs: {
					span: 24,
				},
				sm: {
					span: 8,
				},
			},
			wrapperCol: {
				xs: {
					span: 24,
				},
				sm: {
					span: 16,
				},
			},
			financialInputConsumables: checkPermission('assetmenag:financial:financialInput'), //录入
			financialEditConsumables: checkPermission('assetmenag:financial:financialEdit'), //编辑
			financialDetailsConsumables: checkPermission('assetmenag:financial:financialDetails'), //详情
			financialExportConsumables: checkPermission('assetmenag:financial:financialExport'), //导出
			financialQueryConsumables: checkPermission('assetmenag:financial:financialQuery'), //查询
		}
	},
	computed: {
		hasSelected() {
			return this.selectedRowKeys.length > 0
		},
		assets: {
			get() {
				return this.detailsrow.spu_type ? this.operTypeMap[this.detailsrow.spu_type].text : ''
			},
			set(value) {
				this.detailsrow.spu_type = value
			},
		},
		states: {
			get() {
				return this.detailsrow.state ? this.statusMap[this.detailsrow.state] : ''
			},
			set(value) {
				this.detailsrow.state = value
			},
		},
		isinstrument: {
			get() {
				return this.detailsrow.is_instrument ? this.instrumentMap[this.detailsrow.is_instrument] : ''
			},
			set(value) {
				this.detailsrow.is_instrument = value
			},
		},
		isinspected: {
			get() {
				return this.detailsrow.is_inspected ? this.instrumentMap[this.detailsrow.is_inspected] : ''
			},
			set(value) {
				this.detailsrow.is_inspected = value
			},
		},
		hazard_types: {
			get() {
				return this.detailsrow.hazard_type ? this.detailsrow.hazard_type.split(';') : ''
			},
			set(value) {
				this.detailsrow.hazard_type = value
			},
		},
		storage_conds: {
			get() {
				return this.detailsrow.storage_cond ? this.detailsrow.storage_cond.split(';') : ''
			},
			set(value) {
				this.detailsrow.storage_cond = value
			},
		},
	},
	filters: {
		operTypeFilter(type) {
			return operTypeMap[type].text
		},
		deptFilter(type) {
			return deptMap[type].text
		},
	},
	created() {
		this.get_lis()
		get_dict('goodStatus', (res) => {
			console.log(res)
			this.statusMap = res
		})
		enableParent().then(res => {
			var arry = []
			var array1 = {}
			var data = []
			var data1 = {}
			res.rows.forEach(item => {
				if (item.isCompany == 1) {
					console.log(arry, 'arry=======================')
					if (arry.length != 0) {
						arry.forEach(item1 => {
							if (item1.deptId != item.deptId) {
								array1 = {
									deptId: item.deptId,
									title: item.deptName
								}
							}

						})
						arry.push(array1)
					} else {
						array1 = {
							deptId: item.deptId,
							title: item.deptName
						}
						arry.push(array1)
						console.log(arry, 'arry=======================')

					}

				}
			})
			this.companylist = arry
		})
		dict({
			pageNum: 1,
			pageSize: 10,
			dictType: 'assets_type',
		}).then((res) => {
			this.assettype = res.rows
			this.assettype.map((d) => {
				this.operTypeMap[d.dictCode] = {
					text: d.dictLabel,
				}
			})
		})
		getDeptListEnable().then((res) => {
			const data = res.rows
			if (data.length > 0) {
				const min = Math.min(...data.map((m) => m.parentId))
				this.buildtree2(data, this.deptTree, min)
				this.deptTree.map((d) => {
					if (d.hasOwnProperty('children')) {
						d.children.map((b) => {
							deptMap[b.key] = {
								text: b.title,
							}
							deptMap[d.key] = {
								text: d.title,
							}
						})
					} else {
						deptMap[d.key] = {
							text: d.title,
						}
					}
				})
				this.expandedKeys = data.map((m) => m.parentId)
				this.dataList = data.map((m) => {
					return {
						key: m.deptId,
						title: m.deptName,
					}
				})
			}
		})

	},
	mounted() {
		this.$nextTick(() => {
			var max_h = $('#content_main_center_scroll').height()
			console.log(max_h, 'sssssssss')
			setTimeout(() => {
				console.log($('.ant-table-header').height(), 'aaaaaaaaaaaaa')
				this.scroll_y = max_h - $('.ant-table-header').height()

				console.log(this.scroll_y)
			}, 1000)
		})
		returnDept((res) => {
			console.log(res)
		})
	},
	methods: {
		result() {
			this.asset_type = undefined
			this.name = ''
			this.asset_sn = ''
			this.state = undefined
			this.dates = []
			this.start_date = ''
			this.end_date = ''
			this.company_id = undefined
		},
		changepur_value() {
			this.detailsrow.price = Number(this.detailsrow.value / this.detailsrow.amount).toFixed(2)
		},
		changeamount() {
			var price = Number(this.form.getFieldValue('value') / this.form.getFieldValue('amount')).toFixed(2)
			this.form.setFieldsValue({
				price: price,
			})
		},
		changeprice() {
			this.form.setFieldsValue({
				amount: '1',
			})
			var price = Number(this.form.getFieldValue('value') / this.form.getFieldValue('amount')).toFixed(2)
			this.form.setFieldsValue({
				price: price,
			})
		},
		checkoutChange(checkedList) {
			this.detailsrow.hazard_type = checkedList.join(';')
			if (this.hazard_types.indexOf('其他') == -1) {
				this.els = ''
			}
		},
		checkoutChange2(checkedList) {
			if (checkedList.indexOf('其他') == -1) {
				this.elss = ''
			}
			this.checkList = checkedList
		},
		conditionChange(checkedList) {
			this.detailsrow.storage_cond = checkedList.join(';')
			if (this.storage_conds.indexOf('其他') == -1) {
				this.other = ''
			}
		},
		conditionChange2(checkedList) {
			if (checkedList.indexOf('其他') == -1) {
				this.others = ''
			}
			this.checkList2 = checkedList
		},
		Wareprese() {
			this.form.validateFields((err, values) => {
				if (!err) {
					if (values['hazard_type']) {
						if (values['hazard_type'].indexOf('其他') > -1) {
							if (this.elss == '') {
								this.elss = '无'
							}
							values['hazard_type'] = this.checkList.join(';') + ';' + this.elss
						} else {
							values['hazard_type'] = this.checkList.join(';')
						}
					}
					if (values['storage_cond']) {
						if (values['storage_cond'].indexOf('其他') > -1) {
							if (this.others == '') {
								this.others = '无'
							}
							values['storage_cond'] = this.checkList2.join(';') + ';' + this.others
						} else {
							values['storage_cond'] = this.checkList2.join(';')
						}
					}
					this.companylist.forEach(item => {
						if (item.dept_name == values['company_id']) {
							values['company_id'] = item.dept_id
						}
					})
					var value = values
					let resData = {}
					for (let key in value) {
						resData[key] = value[key]
						resData['create_by'] = this.$store.getters.userInfo.userName
						resData['company_id'] = this.$store.getters.userInfo.companyId
						if (key == 'price' || key == 'value' || key == 'amount') {
							resData[key] = value[key] * 100
						}
					}
					var data = {
						companyId: resData.company_id,
						createBy: resData.create_by,
						hazardType: resData.hazard_type,
						isInspected: resData.is_inspected,
						model: resData.model,
						name: resData.name,
						notes: resData.notes,
						spuType: resData.spu_type,
						storageCond: resData.storage_cond,
						unit: resData.unit,
					}
					// spu_add
					addConsumables(data)
						.then((res) => {
							if (res.code === 200) {
								this.$message.success('保存成功')
								this.$emit('ok')
								this.Warevisible = false
								this.form.resetFields()
								this.elss = ''
								this.others = ''
								this.get_lis()
							} else {
								this.$message.error(res.msg)
							}
						})
						.catch(() => {
							this.$message.error('系统错误，请稍后再试')
						})
				}
			})
		},
		WareCancel() {
			this.Warevisible = false
		},
		Warehousing() {
			this.Warevisible = true
			this.form.resetFields()
			this.$nextTick(() => {
				this.form.setFieldsValue({
					company_id: this.$store.getters.userInfo.company
				})
			})
		},
		leaderid(id) {
			dept_get(id).then((res) => {
				this.form2.setFieldsValue({
					charger: res.leader,
				})
			})
		},
		leaderid2(id) {
			dept_get(id).then((res) => {
				this.form.setFieldsValue({
					charger: res.leader,
				})
			})
			// get_company_name({
			// 	dept_id: id,
			// }).then((res) => {
			// 	this.form.setFieldsValue({
			// 		company_name: res.data,
			// 	})
			// })
		},
		// preservation2(e) {
		// 	this.form2.validateFields((err, values) => {
		// 		if (!err) {
		// 			// var value = values
		// 			// let resData = {}
		// 			// for (let key in value) {
		// 			// 	resData[key] = value[key]
		// 			// 	if (key == 'price' || key == 'value' || key == 'amount') {
		// 			// 		resData[key] = value[key] * 100
		// 			// 	}
		// 			// }
		// 			values['create_by'] = this.$store.getters.userInfo.userName
		// 			fake_sku_entry(values)
		// 				.then((res) => {
		// 					if (res.code === 200) {
		// 						this.$message.success('保存成功')
		// 						this.$emit('ok')
		// 						this.visible2 = false
		// 						this.form2.resetFields()
		// 						this.get_lis()
		// 					} else {
		// 						this.$message.success(res.msg)
		// 					}
		// 				})
		// 				.catch(() => {
		// 					this.$message.error('系统错误，请稍后再试')
		// 				})
		// 		}
		// 	})
		// },
		handleCancel2() {
			this.visible2 = false
		},
		Input() {
			this.visible2 = true
		},
		view_path(path) {
			window.open('https://coa.anliantest.com/oaProxyApi/proxyPython/file/download?path=' + path)
		},
		// handlecompany(value) {
		// 	this.deptlist = []
		// 	this.dept_id = undefined
		// 	// this.company_id = this.companylist[value].dept_id
		// 	this.companylist.forEach((item) => {
		// 		if (item.dept_id == this.company_id) {
		// 			this.deptlist = item.child_lis
		// 		}
		// 	})
		// 	console.log(this.companylist)
		// 	// this.deptlist = this.companylist[value].child_lis
		// },
		handledept(value) {
			this.dept_id = value
		},
		onChange(date, dateString) {
			this.dates = date
			this.start_date = date[0]
			this.end_date = date[1]
		},
		// onCellChange(key, dataIndex, value) {
		// 	const dataSource = [...this.selectedRow]
		// 	const target = dataSource.find((item) => item.key === key)
		// 	if (target) {
		// 		target[dataIndex] = value
		// 		this.selectedRow = dataSource
		// 		console.log(this.selectedRow)
		// 		var list = []
		// 		this.selectedRow.forEach((item) => {
		// 			list.push({
		// 				id: item.id,
		// 				value: item.value,
		// 			})
		// 		})
		// 		console.log(list)
		// 	}
		// },
		onSelectChange(selectedRowKeys) {
			this.selectedRowKeys = selectedRowKeys
		},
		showSizeChange(current, pageSize) {
			this.pageSize = pageSize
			this.current = current
			this.get_lis()
		},
		onShowSizeChange(current, pageSize) {
			this.selectedRowKeys = []
			this.selectedRow = []
			this.current = current
			this.get_lis()
		},
		handlestate(value) {
			this.state = value
		},
		handlestate2(value) {
			this.state2 = value
		},
		moneyOk() {
			var list = []
			this.selectedRow.forEach((item) => {
				list.push({
					id: item.id,
					value: item.value * 100,
				})
			})
			batch_save_value({
				data: list,
			})
				.then((res) => {
					if (res.code == 200) {
						this.changevisible = false
						this.$message.success('保存成功')
					} else {
						this.$message.success(res.msg)
					}
				})
				.catch(() => {
					this.$message.error('系统错误，请稍后再试')
				})
		},
		moneyCancel() {
			this.changevisible = false
		},
		modification() {
			this.selectedRow = []
			this.selectedRowKeys.forEach((item) => {
				this.selectedRow.push(this.data[item])
			})
			this.changevisible = true
			console.log(this.selectedRow)
		},
		buildtree2(list, arr, parentId) {
			list.forEach((item) => {
				if (item.parentId === parentId) {
					var child = {
						key: item.deptId,
						value: item.deptId, // value是给modal的select用的，2者属性不一样
						title: item.deptName,
						scopedSlots: {
							title: 'title',
						},
						children: [],
					}
					this.buildtree2(list, child.children, item.deptId)
					if (child.children.length === 0) {
						delete child.children
					}
					arr.push(child)
				}
			})
		},
		get_lis() {
			// spu_get_list
			consumablesList({
				pageSize: this.pageSize,
				pageIndex: this.current,
				name: this.name,
				spuSn: this.asset_sn,
				companyId: this.company_id,
				spuType: this.asset_type,
				sortField: 'id',
				sortOrder: 'desc'
			}).then((res) => {
				this.total = res.data.totalCount
				this.data = res.data.list
				// this.data.forEach((item) => {
				// 	item.price = item.price / 100
				// 	item.value = item.value / 100
				// 	item.amount = item.amount / 100
				// })
			})
		},
		add() {
			this.visible = true
		},
		Exadd() {
			this.visibleClaim = true
		},
		examine() {
			this.visibleexamine = true
		},
		handleOk(e) {
			this.loading = true
			setTimeout(() => {
				this.visible = false
				this.loading = false
			}, 2000)
		},
		handleCancel(e) {
			this.visible = false
		},
		handleOk2(e) {
			this.loading = true
			setTimeout(() => {
				this.visibleClaim = false
				this.loading = false
			}, 2000)
		},
		handleOk3(e) {
			this.loading = true
			setTimeout(() => {
				this.visibleexamine = false
				this.loading = false
			}, 2000)
		},
		query() {
			this.current = 1
			this.get_lis()
		},
		exp() {
			downLoadXlxs2(process.env.VUE_APP_API_BASE_URL + '/daily/consumables/list_excel',
				{
					name: this.name,
					spuSn: this.asset_sn,
					companyId: this.company_id,
					spuType: this.asset_type,

				})
			// get_spu_xlsx({
			// 	page_size: 99999,
			// 	page_num: 1,
			// 	name: this.name,
			// 	id: this.asset_sn,
			// 	start_date: this.start_date,
			// 	end_date: this.end_date,
			// 	dept_id: this.dept_id,
			// 	company_id: this.company_id,
			// 	excel: 1
			// })
		},
		details(rows) {
			this.detailsvisible = true
			var row = {
				storage_num: rows.storageNum,
				amount: rows.amount,
				company_id: rows.companyId,
				company_name: rows.companyName,
				create_by: rows.createBy,
				create_time: rows.createTime,
				dept_id: rows.deptId,
				dept_name: rows.deptName,
				hazard_type: rows.hazardType,
				id: rows.id,
				is_inspected: rows.isInspected,
				model: rows.model,
				name: rows.name,
				notes: rows.notes,
				period: rows.period,
				price: rows.price,
				short_limit: rows.shortLimit,
				spu_sn: rows.spuSn,
				spu_type: rows.spuType,
				spu_type_name: rows.spuTypeName,
				storage_cond: rows.storageCond,
				storage_num: rows.storageNum,
				unit: rows.unit,
				update_by: rows.updateBy,
				update_time: rows.updateTime
			}
			console.log(row, 'row====================')
			this.detailsrow = row
			this.detailsrow.att_paths = row.att_path ? row.att_path.split(',') : []
		},
		Warehousingdetails(row) {
			this.Warehousingvisible = true
			this.detailsrow = row
			console.log(row)
		},
		WarehousingOk() {
			this.Warehousingvisible = false
		},
		WarehousingCancel() {
			this.Warehousingvisible = false
		},
		detailsOk() {
			this.detailsvisible = false
		},
		detailsCancel() {
			this.detailsvisible = false
		},
		edit(row) {
			console.log(row, 'row======================')
			this.editvisible = true
			var rows = {
				storage_num: row.storageNum,
				amount: row.amount,
				company_id: row.companyId,
				company_name: row.companyName,
				create_by: row.createBy,
				create_time: row.createTime,
				dept_id: row.deptId,
				dept_name: row.deptName,
				hazard_type: row.hazardType,
				id: row.id,
				is_inspected: row.isInspected,
				model: row.model,
				name: row.name,
				notes: row.notes,
				period: row.period,
				price: row.price,
				short_limit: row.shortLimit,
				spu_sn: row.spuSn,
				spu_type: row.spuType,
				spu_type_name: row.spuTypeName,
				storage_cond: row.storageCond,
				storage_num: row.storageNum,
				unit: row.unit,
				update_by: row.updateBy,
				update_time: row.updateTime
			}
			console.log(rows, 'rows======================')
			let resData = {}
			for (let key in rows) {
				resData[key] = rows[key]
				// resData['is_inspected'] = rows['is_inspected'] + ''
				resData['update_by'] = this.$store.getters.userInfo.userName
			}
			this.detailsrow = resData
			if (this.detailsrow['hazard_type']) {
				if (this.detailsrow['hazard_type'].indexOf('其他') != -1) {
					this.els = this.detailsrow['hazard_type'].split(';')[this.detailsrow['hazard_type'].split(';')
						.length - 1]
				} else {
					this.els = ''
				}
			} else {
				this.els = ''
			}
			if (this.detailsrow['storage_cond']) {
				if (this.detailsrow['storage_cond'].indexOf('其他') != -1) {
					this.other = this.detailsrow['storage_cond'].split(';')[this.detailsrow['storage_cond'].split(';')
						.length - 1]
				} else {
					this.other = ''
				}
			} else {
				this.other = ''
			}
			// this.detailsrow.att_paths = row.att_path.split(',')
		},
		editOk() {
			// this.detailsrow['hazard_type']+';'+this.els
			var detailsrow = this.detailsrow
			if (detailsrow['hazard_type']) {
				if (detailsrow['hazard_type'].indexOf('其他') > -1) {
					var row = detailsrow['hazard_type'].split(';')[this.detailsrow['hazard_type'].split(';').length -
						1]
					if (this.els == '') {
						this.els = '无'
					}
					if (row == '其他') {
						detailsrow['hazard_type'] = detailsrow['hazard_type'] + ';' + this.els
					} else {
						detailsrow['hazard_type'] = detailsrow['hazard_type'].replace(row, this.els)
					}
				}
			}
			if (detailsrow['storage_cond']) {
				if (detailsrow['storage_cond'].indexOf('其他') > -1) {
					var row = detailsrow['storage_cond'].split(';')[this.detailsrow['storage_cond'].split(';').length -
						1]
					if (this.other == '') {
						this.other = '无'
					}
					if (row == '其他') {
						detailsrow['storage_cond'] = detailsrow['storage_cond'] + ';' + this.other
					} else {
						detailsrow['storage_cond'] = detailsrow['storage_cond'].replace(row, this.other)
					}
				}
			}
			// delete detailsrow.amount
			// delete detailsrow.company_name
			// delete detailsrow.dept_name
			let resData = {}
			for (let key in detailsrow) {
				resData[key] = detailsrow[key]
				if (key == 'price' || key == 'value' || key == 'amount') {
					resData[key] = detailsrow[key] * 100
				}
				delete resData['amount']
				delete resData['company_name']
				delete resData['dept_name']
			}
			var data = {
				id: resData.id,
				companyId: resData.company_id,
				createBy: resData.create_by,
				hazardType: resData.hazard_type,
				isInspected: resData.is_inspected,
				model: resData.model,
				name: resData.name,
				notes: resData.notes,
				spuType: resData.spu_type,
				storageCond: resData.storage_cond,
				unit: resData.unit,
			}
			// spu_update
			editConsumables(data)
				.then((res) => {
					if (res.code == 200) {
						this.editvisible = false
						this.$message.success('编辑成功')
						this.get_lis()
					} else {
						this.$message.success(res.msg)
					}
				})
				.catch(() => {
					this.$message.error('系统错误，请稍后再试')
				})
		},
		editCancel() {
			this.editvisible = false
		},
	},
}
</script>
<style>
.dialog {
	display: flex;
	justify-content: space-between;
}

.flex {
	display: flex;
}

.center {
	text-align: center;
	width: 832px;
}

.dialog .dialog_item {
	margin-bottom: 5px;
	width: 220px;
	display: flex;
	justify-content: space-between;
}

.Exhi {
	display: inline-block;
	border: 1px solid black;
	width: 100px;
	text-align: left;
	color: steelblue;
}

.form_item {
	float: left;
	width: 50%;
	height: 50px;
	margin-bottom: 10px;
}

.form_item2 {
	float: left;
	width: 33%;
	height: 50px;
	margin-bottom: 10px;
}

.form_item3 {
	float: left;
	width: 100%;
	height: 50px;
	margin-bottom: 10px;
}

.editable-cell {
	position: relative;
}

.editable-cell-input-wrapper,
.editable-cell-text-wrapper {
	padding-right: 24px;
}

.editable-cell-text-wrapper {
	padding: 5px 24px 5px 5px;
}

.editable-cell-icon,
.editable-cell-icon-check {
	position: absolute;
	right: 0;
	width: 20px;
	cursor: pointer;
}

.editable-cell-icon {
	line-height: 18px;
	display: none;
}

.editable-cell-icon-check {
	line-height: 28px;
}

.editable-cell:hover .editable-cell-icon {
	display: inline-block;
}

.editable-cell-icon:hover,
.editable-cell-icon-check:hover {
	color: #108ee9;
}

.editable-add-btn {
	margin-bottom: 8px;
}

.border_a_input {
	border: 1px solid #ddd;
}

.view_path {
	width: 100%;
	float: left;
	cursor: pointer;
}

.resize-table-th {
	position: relative;
}

.table-draggable-handle {
	/* width: 10px !important; */
	height: 100% !important;
	left: auto !important;
	right: -5px;
	cursor: col-resize;
	touch-action: none;
	border: none;
}
</style>
